import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CoursesComponent } from './courses/courses.component';
import { CatalogComponent } from './catalog/catalog.component';
import { LearnComponent } from './learn/learn.component';
import { LearnToFlyComponent } from './learn-to-fly/learn-to-fly.component';
import { YoungEaglesVoucherRedeemptionComponent } from './young-eagles-voucher-redeemption/young-eagles-voucher-redeemption.component';
import { FeedsComponent } from './feeds/feeds.component';
import { LibraryComponent } from './library/library.component';
import { InvitationAcceptanceComponent } from './invitation-acceptance/invitation-acceptance.component';
import { ConnectionAcceptanceComponent } from './connection-acceptance/connection-acceptance.component';
import { TokenClaimComponent } from './token-claim/token-claim.component';
import { MagicLinkFailureComponent } from './magic-link-failure/magic-link-failure.component';
import { DiscoverComponent } from './discover/discover.component';
import { DocumentContainerComponent } from './document/document-container.component';
import { CoursesResolver } from '../resolvers/courses-resolver';
import { UserResolver } from '../course/resolvers/user-resolver';
import { YeGuard } from '../guards/ye-guard';

const routes: Routes = [
  { path: '', redirectTo: 'courses', pathMatch: 'full' },
  {
    path: 'courses',
    canActivate: [YeGuard],
    component: CoursesComponent
  },
  { path: 'catalog', component: CatalogComponent },
  {
    path: 'learn',
    resolve: { courses: CoursesResolver },
    canActivate: [YeGuard],
    component: DiscoverComponent
  },
  // { path: 'learn', component: LearnComponent },
  {
    path: 'figure/:figureId',
    resolve: {
      user: UserResolver
    },
    loadComponent: () =>
      import('../components/figure/figure.component').then((c) => c.FigureComponent)
  },
  {
    path: 'learn-to-fly',
    canActivate: [YeGuard],
    resolve: { courses: CoursesResolver },
    component: LearnToFlyComponent
  },
  { path: 'redeem-voucher', component: YoungEaglesVoucherRedeemptionComponent },
  { path: 'news', component: FeedsComponent },
  { path: 'library', component: LibraryComponent },
  {
    path: 'accept/:token',
    component: InvitationAcceptanceComponent
  },
  {
    path: 'connect/:token',
    component: ConnectionAcceptanceComponent
  },
  {
    path: 'claim/:code',
    component: TokenClaimComponent
  },
  {
    path: 'claim',
    component: TokenClaimComponent
  },
  {
    path: 'link/:code',
    component: MagicLinkFailureComponent
  },
  {
    path: 'document',
    component: DocumentContainerComponent,
    children: [
      {
        path: '',
        data: {
          relativeBackLink: '../..'
        },
        loadChildren: () =>
          import('../components/pspdfkit-views/resource/pspdfkit-view.module').then(
            (m) => m.PspdfkitViewModule
          )
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class HomeRoutingModule {}
